import React from 'react';

export const Footer = () => <div>I am the footer</div>;

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx